// extracted by mini-css-extract-plugin
export default {"Owner":"Comment_Owner__YGmXK","Date":"Comment_Date__QVPnD"};